import React from "react";
import { useParams } from "react-router-dom";
import ContinuousPractice from "../Lesson/ContinuousPractice";
import PracticeList from "./PracticeList";

// Roles that should render PracticeList instead of ContinuousPractice
const PRACTICE_LIST_ROLES = ["flow-into-apex"];

const PracticeRouter = () => {
  const { role } = useParams();

  // Check if this role should use PracticeList
  const isPracticeList = PRACTICE_LIST_ROLES.includes(role?.toLowerCase());

  if (isPracticeList) {
    return <PracticeList />;
  }

  return <ContinuousPractice />;
};

export default PracticeRouter;
